import api from "../apiInstance";
import { UpdatePictureOrder } from "./interfaces/Pictures";

export const updateProductPictureOrder = async (data: UpdatePictureOrder): Promise<boolean> => {
    const res = await api.post(process.env.REACT_APP_RENTIC_API_URL! + '/files/picture/update_order/' + data.fileId.toString(), data)
    return res.data
}

export const deletePictureFile = async (fileId: number): Promise<number> => {
    const res = await api.delete(process.env.REACT_APP_RENTIC_API_URL! + '/files/picture/delete_file/' + fileId.toString());
    return res.data;
}